import { useDrawer } from '@consumidor-positivo/aurora';
import { usePrivatePagesStates } from './data';
import { useRedline } from '@libs/redline';

export const useCpHeader = () => {
  const { track: trackRedline } = useRedline();

  const { drawerOpen, handleOpenDrawer } = useDrawer({
    menu: false,
    notification: false,
  });

  const { dataSourceNavbar, dataSourceNavbarVertical } = usePrivatePagesStates();

  function firstName(name: string) {
    const splitName = name.split(' ');
    return splitName[0];
  }

  async function handleNavigate(path: string, title: string) {
    trackRedline.userTracking.elementClicked({
      elementType: 'button/text',
      name: path,
      text: title,
      location: 'navbar',
    });

    window.location.href = path;
  }

  return {
    dataSourceNavbar,
    dataSourceNavbarVertical,
    drawerOpen,
    firstName,
    handleOpenDrawer,
    handleNavigate,
  };
};
